<template>
  <div id="fade-in"
       ref="fadeInRef"
       :class="`fade-in-section ${isVisible ? 'is-visible': ''}`">
    <slot />
  </div>
</template>
<script>
import Vue from 'vue';

export default {
	name: 'FadeIn',

	props: {
	},

	data: function() {
		return {
			isVisible: false
		};
	},

	mounted: function() {
		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				this.isVisible = entry.isIntersecting;
			});
		});

		observer.observe(this.$refs.fadeInRef);
	},

	methods: {
	}
};
</script>
<style lang="scss" scoped>
.fade-in-section {
  opacity: 0;
  transform: translateY(20vh);
  visibility: hidden;
  transition: opacity 0.6s ease-out, transform 1.2s ease-out;
  will-change: opacity, visibility;

	&.is-visible {
		opacity: 1;
		transform: none;
		visibility: visible;
	}
}
</style>